<template>
  <div class="order-list">
    <van-nav-bar
      title="订单信息"
      left-text="刷新"
      right-text="电子发票"
      @click-left="query"
      @click-right="handleToInvoiceList"
    />
    <van-tabs v-model="active">
      <van-tab title="可申请">
        <div class="van-address-edit">
          <div class="van-address-edit__fields">
            <van-checkbox-group v-model="checkedArray" ref="checkboxGroup" @change="onCheckedChange">
              <template v-for="row in data">
                <div class="order-list-card" v-if="row.invoice_amount === 0">
                  <van-panel :key="row.id">
                    <div style="padding: 10px 10px;">
                      <span v-for="detail in row.details" class="order-list-item">
                        {{ detail.goods_name }} × {{ detail.count }}<br>
                      </span>
                    </div>
                    <template #header>
                      <van-row style="padding: 10px 10px;">
                        <van-col :span="17">
                          <van-checkbox :name="row.id">
                            <span class="order-code">
                              &nbsp;{{ row.code }}
                            </span>
                          </van-checkbox>
                        </van-col>
                        <van-col :span="7" style="text-align: right">
                          <span class="order-price">
                            ￥{{ row.receivable_amount | toThousandFilter }}
                          </span>
                        </van-col>
                      </van-row>
                    </template>
                    <template #footer>
                      <van-row>
                        <van-col :span="2">
                          <van-icon name="clock" class="order-list-clock" />&nbsp;
                        </van-col>
                        <van-col :span="17">
                          <span class="order-list-date">
                            {{ row.order_date }}
                          </span>
                        </van-col>
                        <van-col :span="5" style="text-align: right;">
                          <van-tag plain type="primary">可申请</van-tag>
                        </van-col>
                      </van-row>
                    </template>
                  </van-panel>
                </div>
              </template>
            </van-checkbox-group>
          </div>
        </div>
      </van-tab>
      <van-tab title="已申请">
        <div class="van-address-edit">
          <div class="van-address-edit__fields">
            <template v-for="row in data">
              <div class="order-list-card" v-if="row.invoice_amount > 0">
                <van-panel :key="row.id">
                  <div style="padding: 10px 10px;">
                    <span v-for="detail in row.details" class="order-list-item">
                      {{ detail.goods_name }} × {{ detail.count }}<br>
                    </span>
                  </div>
                  <template #header>
                    <van-row style="padding: 10px 10px;">
                      <van-col :span="17">
                        <span class="order-code">
                      &nbsp;  {{ row.code }}
                        </span>
                      </van-col>
                      <van-col :span="7" style="text-align: right">
                        <span class="order-price">
                          ￥{{ row.receivable_amount | toThousandFilter }}
                        </span>
                      </van-col>
                    </van-row>
                  </template>
                  <template #footer>
                    <van-row>
                      <van-col :span="2">
                        <van-icon name="clock" class="order-list-clock" />&nbsp;
                      </van-col>
                      <van-col :span="17">
                        <span class="order-list-date">
                          {{ row.order_date }}
                        </span>
                      </van-col>
                      <van-col :span="5" style="text-align: right;">
                        <van-tag plain type="success">已申请</van-tag>
                      </van-col>
                    </van-row>
                  </template>
                </van-panel>
              </div>
            </template>
          </div>
        </div>
      </van-tab>
      <van-tab title="全部">
        <div class="van-address-edit">
          <div class="van-address-edit__fields">
            <template v-for="row in data">
              <div class="order-list-card">
                <van-panel :key="row.id">
                  <div style="padding: 10px 10px;">
                    <span v-for="detail in row.details" class="order-list-item">
                      {{ detail.goods_name }} × {{ detail.count }}<br>
                    </span>
                  </div>
                  <template #header>
                    <van-row style="padding: 10px 10px;">
                      <van-col :span="17">
                        <span class="order-code">
                    &nbsp;    {{ row.code }}
                        </span>
                      </van-col>
                      <van-col :span="7" style="text-align: right">
                        <span class="order-price">
                          ￥{{ row.receivable_amount | toThousandFilter }}
                        </span>
                      </van-col>
                    </van-row>
                  </template>
                  <template #footer>
                    <van-row>
                      <van-col :span="2">
                        <van-icon name="clock" class="order-list-clock" />&nbsp;
                      </van-col>
                      <van-col :span="17">
                              <span class="order-list-date">
                                {{ row.order_date }}
                              </span>
                      </van-col>
                      <van-col :span="5" style="text-align: right;">
                        <van-tag v-if="row.invoice_amount === 0" plain type="primary">可申请</van-tag>
                        <van-tag v-else plain type="success">已申请</van-tag>
                      </van-col>
                    </van-row>
                  </template>
                </van-panel>
              </div>
            </template>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <van-submit-bar :price="totalAmount * 100" button-text="申请发票" @submit="handleApplyInvoice">
      <van-checkbox v-model="checkAll" @click="handleCheckAll">全选</van-checkbox>
    </van-submit-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { listByMemberOfSellOrder } from '@/api/wx-fwh'
export default {
  name: 'WxOrderList',
  data() {
    return {
      active: 0,
      data: [],
      checkedArray: [],
      checkAll: true
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    totalAmount() {
      let totalAmount = 0
      if (this.checkedArray.length > 0) {
        this.checkedArray.forEach(orderId => {
          const order = this.data.find(order => order.id === orderId)
          if (order) {
            totalAmount += parseFloat(parseFloat(order.receivable_amount || 0)
              .toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
          }
        })
      }
      return parseFloat(totalAmount.toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
    }
  },
  mounted() {
    this.active = this.$route.params.active || 0
    this.query()
  },
  methods: {
    onCheckedChange(val) {
      this.checkAll = val && val.length === this.data.filter(order => order.invoice_id === 0).length
    },
    handleToInvoiceList() {
      this.$router.push('/wx-invoice-list')
    },
    handleApplyInvoice() {
      if (this.totalAmount === 0) {
        this.alert('请您选择需要申请发票的订单')
      } else {
        const selectedOrderList = []
        this.checkedArray.forEach(orderId => {
          selectedOrderList.push(this.data.find(order => order.id === orderId))
        })
        localStorage.setItem('selectedOrderList', JSON.stringify(selectedOrderList))
        this.$router.push('/wx-apply-invoice')
      }
    },
    handleCheckAll() {
      if (this.checkAll) {
        this.$refs.checkboxGroup.toggleAll(true)
      } else {
        this.$refs.checkboxGroup.toggleAll()
      }
    },
    query() {
      listByMemberOfSellOrder({
        sort: 'order_date',
        order: 'desc'
      }).then(resp => {
        this.data = resp.rows || []
        this.checkedArray = []
        this.data.forEach(order => {
          if (order.invoice_amount === 0) {
            this.checkedArray.push(order.id)
          }
        })
        this.checkAll = true
      })
    }
  }
}
</script>

<style scoped>
  .order-list {
    color: #323233;
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
      Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
  }
  .order-list-card {
    margin-top: 20px;
  }
  .order-list-item {
    font-size: 12px;
  }
  .order-list-date {
    font-size: 14px;
  }
  .order-list-clock {
    color: skyblue;
    font-size: 18px;
  }
  .order-code {
    font-size: 14px;
  }
  .order-price {
    color: darkorange;
    font-size: 18px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/wxfwh/apply-invoice/wx-order-list.vue